/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { Sidebar } from './components/Sidebar';
import { Outlet } from 'react-router-dom';
import { useSideBarHandler } from './hooks/useSideBarHandler';
import useGetCurrentUser from './hooks/useGetCurrentUser';
import AppLoader from '../../common-components/AppLoader';
import Header from './components/Header';

function MainLayoutContent() {
  const { isSidebarOpen, xsScreen, toggleSidebar } = useSideBarHandler();
  const { currentUser, isCurrentUserLoading } = useGetCurrentUser();

  useEffect(() => {
    if (xsScreen && isSidebarOpen) {
      toggleSidebar(false);
    }
  }, [xsScreen]);

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100dvh',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      {isCurrentUserLoading || !currentUser ? (
        <AppLoader />
      ) : (
        <>
          <Sidebar />
          <Box sx={{ display: 'flex', flex: 1, marginLeft: isSidebarOpen && !xsScreen ? '280px' : xsScreen ? 0 : '60px', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
            {isSidebarOpen ? null : <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />}
            <Outlet />
          </Box>
        </>
      )}
    </Box>
  );
}

export default function MainLayout() {
  return <MainLayoutContent />;
}
